import { LoadState } from "../../constants/enums";
import { IDistinctRecordState } from "./distinctrecord.types";

export const initialDistinctRecordState: IDistinctRecordState = {
  list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
